export default {"src":"/_next/static/media/code.327404e8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};